module.exports = __webpack_public_path__ + "static/media/RESEARCH_astro2020.7897b4cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/RESEARCH_astro2020.jpg
// module id = 157
// module chunks = 0